module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_What_Box.01621e37.png";